import React from 'react';

export const QuickStats = ({ stats, t }) => {
  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <h3 className="h6 fw-bold mb-4">{t('dashboard.index.quick_stats.title')}</h3>
        <div className="d-flex flex-column gap-3">
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted">{t('dashboard.index.quick_stats.family_members')}</span>
            <span className="fw-bold">{stats.family_members}</span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted">{t('dashboard.index.quick_stats.active_children')}</span>
            <span className="fw-bold text-success">{stats.active_children}</span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span className="text-muted">{t('dashboard.index.quick_stats.programs_enrolled')}</span>
            <span className="fw-bold text-primary">{stats.programs_enrolled}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
